export default __webpack_public_path__ + "images/speedometer-outline-white.b1927086a917eee106aed44c33659e22.png";